import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.84487 4.28571V2.42857C7.84487 1.91574 7.42913 1.5 6.91629 1.5H3.20201C2.68917 1.5 2.27344 1.91574 2.27344 2.42857V13.5714C2.27344 14.0843 2.68917 14.5 3.20201 14.5H6.91629C7.42913 14.5 7.84487 14.0843 7.84487 13.5714V11.25M10.9401 10.7857L13.7258 8L10.9401 5.21429M13.7258 8H5.6782",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLogout;
